
    // Expose lib version
    window.__RY_UI_VERSION__ = '1.0.15';
  